import { ModalVinculateAnalytes } from "../ModalVinculateAnalytes"
import Input from "../../../../atoms/Input"
import InfiniteScroll from "../../../../atoms/InfiniteScroll"
import RcmpCheckBox from "../../../../atoms/Checkbox"
import RcmpLoading from "../../../../atoms/Loading"
import intl from "react-intl-universal"
import styles from "./index.module.scss"

export const AnalytePicker = ({
  listAnalytesHistory,
  setBisOpenModal,
  setListAnalytesAddInEqp,
  listAnalytesAddInEqp,
  infoInfititeScroll,
  fnNextPage,
  isChecked,
  fnHandleChange,
  fnSearchAnalyte,
  removeDuplicated,
  everyPropertiesIsChecked,
  fnHandleSelectAnalyte,
  isLoad,
  bControl = false,
  setIsChanged,
  nPage = null
}) => {
  return (
    <ModalVinculateAnalytes
      listHistory={listAnalytesHistory}
      onCancel={() => setBisOpenModal(false)}
      onClick={setListAnalytesAddInEqp}
      listAnalytesAddEquipment={listAnalytesAddInEqp}
    >
      <Input
        width="100%"
        className={styles.inputSearch}
        isSearch
        placeholder={intl.get("ciq.type_here")}
        label={intl.get("ciq.search_name")}
        onChange={fnSearchAnalyte}
      />

      <InfiniteScroll
        fnNext={fnNextPage}
        nTotalPages={infoInfititeScroll?.last_page || 0}
        nDataLength={removeDuplicated?.length || 0}
        bStopPagination={isLoad}
        bResetPage={nPage === 1}
        scrollableTarget="modal-overflow-content"
        className={styles.scroll}
      >
        <ul className={styles.listAnalytes}>
          {bControl ? (
            <>
              <li>
                <span className={styles.firstColumn}>
                  <RcmpCheckBox
                    cLabel={intl.get("ciq.name_exame_analyte")}
                    checked={isChecked}
                    onChange={fnHandleChange}
                  />
                  {removeDuplicated.some((item) => item.bChecked === true) &&
                    !everyPropertiesIsChecked && (
                      <span
                        className={styles.parcial}
                        style={{
                          top: "0.5rem",
                        }}
                      />
                    )}
                </span>
                <span>{intl.get("unit")}</span>
                <span>{intl.get("ciq.create_analytes.n_decimals")}</span>
                <span>
                  {intl.get("ciq.header_table_link_analytes.maximum_imprecision")}
                </span>
              </li>

              {removeDuplicated?.map((item) => (
                <li
                  key={item.anlt_nid}
                  className={styles.line}
                  onClick={() => fnHandleSelectAnalyte(item)}
                >
                  <span className={styles.firstColumn}>
                    <RcmpCheckBox cLabel={item.anlt_cname} checked={item.bChecked} />
                  </span>
                  <span className={styles.secondColumn}>{item.anlt_unit_of_measure}</span>{" "}
                  <span className={styles.thirdColumn}>
                    {item.anlt_decimal_places || "---"}
                  </span>
                  <span className={styles.thirdColumn}>
                    {item?.maximum_imprecision || "---"}
                  </span>
                </li>
              ))}
            </>
          ) : (
            <>
              <li
                style={{
                  gridTemplateColumns: "1fr 0.5fr 0.5fr",
                }}
              >
                <span className={styles.firstColumn}>
                  <RcmpCheckBox
                    cLabel={intl.get("ciq.name_exame_analyte")}
                    checked={isChecked}
                    onChange={fnHandleChange}
                  />
                  {removeDuplicated.some((item) => item.bChecked === true) &&
                    !everyPropertiesIsChecked && <span className={styles.parcial} />}
                </span>
                <span className={styles.fullWidth}>
                  {intl.get("ciq.header_table_list_analyte.sector")}
                </span>
                <span className={styles.fullWidth}>
                  {intl.get("ciq.type_exame_analyte_selected")}
                </span>
              </li>

              {removeDuplicated?.map((item) => (
                <li
                  key={item.anlt_nid}
                  className={styles.line}
                  onClick={() => fnHandleSelectAnalyte(item)}
                  style={{
                    gridTemplateColumns: "1fr 0.5fr 0.5fr",
                  }}
                >
                  <span className={styles.firstColumn}>
                    <RcmpCheckBox cLabel={item.anlt_cname} checked={item.bChecked} />
                  </span>
                  <span className={styles.secondColumn}>{item.anlt_sector}</span>{" "}
                  <span className={styles.thirdColumn}>{item.anlt_type}</span>
                </li>
              ))}
            </>
          )}
          <li className={styles.lastLine}>
            <span>
              {listAnalytesHistory.filter((item) => item.bChecked === true).length || 0}{" "}
              {intl.get("seleteds")}
            </span>
          </li>
        </ul>
        {isLoad && (
          <div style={{ marginTop: "1rem" }}>
            <RcmpLoading bShow={true} size={60} />
          </div>
        )}
      </InfiniteScroll>
    </ModalVinculateAnalytes>
  )
}
